// src/screens/pass/PassEnterOTPView.jsx
import React, { useEffect, useMemo, useState } from "react";
import { Button, Center, Container, Space, Text, TextInput, Title } from "@mantine/core";
import { compare2FASitePass } from "../../atoms/passNetwork";

export default function PassEnterOTPView({ siteId, name, phoneE164, onBack, onVerified }) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const disabled = useMemo(() => code.length < 6 || loading, [code, loading]);

  useEffect(() => {
    setErr("");
  }, [code]);

  async function onConfirm() {
    if (!code) {
      setErr("Verification code is required.");
      return;
    }

    setLoading(true);
    setErr("");

    try {
      const res = await compare2FASitePass({
        siteId,
        name,
        phoneE164,
        twoFa: code,
      });

      const ok = Number(res?.status) === 1;
      const data = res?.data || {};

      if (!ok) {
        throw new Error(data?.message || "Failed to verify code.");
      }

      const verified = data?.verified === true || data?.verified === 1 || data?.verified === "1";
      if (!verified) {
        setErr("Invalid verification code.");
        return;
      }

      onVerified();
    } catch (e) {
      setErr(e?.message || "Failed to verify code.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <Container size={700} px="md" style={{ minHeight: "100vh" }}>
      <Center style={{ minHeight: "100vh" }}>
        <div style={{ width: "100%" }}>
          <Title order={3} ta="center">
            Enter Verification Code
          </Title>

          <Space h="md" />

          <TextInput
            label="Verification Code"
            placeholder="123456"
            value={code}
            onChange={(e) => {
              const digits = e.currentTarget.value.replace(/\D+/g, "").slice(0, 6);
              setCode(digits);
            }}
            inputMode="numeric"
            size="md"
          />

          {err ? (
            <Text c="red" mt="md">
              {err}
            </Text>
          ) : null}

          <Space h="md" />

          <Button fullWidth size="md" onClick={onConfirm} loading={loading} disabled={disabled}>
            Confirm Code
          </Button>

          <Button variant="subtle" fullWidth mt="sm" onClick={onBack}>
            Back
          </Button>
        </div>
      </Center>
    </Container>
  );
}
